require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-update-what-should-the-u-s-prioritize-in-ida-20-replenishment.json") })
        }
      }, "path---en-us-update-what-should-the-u-s-prioritize-in-ida-20-replenishment");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-update-what-should-the-u-s-prioritize-in-ida-20-replenishment!./.cache/json/en-us-update-what-should-the-u-s-prioritize-in-ida-20-replenishment.json
// module id = 851
// module chunks = 231608221292675